module.exports = __webpack_public_path__ + "img/user@2x.1d07be79.png";